import { Category } from "@CommonApi/categories";
import { omniAtom } from "src/utils/atoms";

export const importStoreSummaryModalDataAtom = omniAtom({
  prefix: "src/modals/importStoreSummary",
  key: "data",
  value: null as null | Category,
});
